import airline from "../assets/images/KIM4x4_Airline_mitGurt.png";

const AirlineSection = () => {
  return (
    <section className="px-6 max-w-screen-2xl mx-auto mb-10 h-20 w-full xl:mb-20">
      <img
        src={airline}
        alt="airline_mitGurt"
        className="h-full w-full object-cover object-left"
      />
    </section>
  );
};

export default AirlineSection;
